import {AxiosError, AxiosResponse} from 'axios';
import {useMutation} from 'react-query';
import {IPostCreditStoreOrderTransactionPayload} from '../postCreateCreditStoreOrderTransaction/postCreateCreditStoreOrderTransaction';
import postCreateCashBackStoreOrderTransaction from './postCreateCashBackStoreOrderTransaction';

const usePostCreateCashBackStoreOrderTransaction = (
  handleAfterSuccess?: (response: AxiosResponse<any>) => void,
  handleOnError?: (statusCode: number | null) => void,
) => {
  return useMutation({
    mutationFn: (payload: IPostCreditStoreOrderTransactionPayload) =>
      postCreateCashBackStoreOrderTransaction(payload),

    onSuccess: response => {
      handleAfterSuccess?.(response);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      const status = error.response?.status ?? null;
      handleOnError?.(status);
    },
  });
};

export default usePostCreateCashBackStoreOrderTransaction;
